var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('a-tabs',{attrs:{"defaultActiveKey":"1"}},[_c('a-tab-pane',{key:"1",attrs:{"tab":"设备管理"}},[_c('devManagemen')],1),_c('a-tab-pane',{key:"2",attrs:{"tab":"税票参数"}},[_c('printerParameters')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }